import React, { FC, memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { coreSelectors } from '@ucheba/store/core'
import { ILimitedListProps } from '../types'
import { Spacing } from '../../Spacing/desktop'
import { Button } from '../../Button/desktop'
import UnlockIcon from '../../../icons/icon__unlock.svg'
import { LimitedListContext, useLimitedListCore } from '../bll'

/** Ограничивает вывод списка кнопкой */
const LimitedList: FC<ILimitedListProps> = (props) => {
  const isTouch = useSelector(coreSelectors.isTouch)
  const {
    items,
    limit = 0,
    onShowAll,
    buttonText = 'Показать все',
    id,
    isAuth,
    redirect,
    children,
    showButton,
    buttonSpacing = isTouch ? 'large' : 'xlarge',
    showAllButtonLinkIsLink = true,
    total = 0,
  } = props
  const { limitedItems, countShowed, onClickShowAll, isAuthNeed } = useLimitedListCore({
    limit,
    onShowAll,
    redirect,
    items,
    isAuth,
    id,
    showAllButtonLinkIsLink,
  })

  const value = useMemo(() => {
    return {
      limitedItems,
      isOpen: !(
        (!!countShowed && ((total && total > limit) || items.length > limit)) ||
        showButton
      ),
    }
  }, [countShowed, items.length, limit, limitedItems, showButton, total])

  return (
    <div id={id}>
      <LimitedListContext.Provider value={value}>
        <LimitedListContext.Consumer>{children}</LimitedListContext.Consumer>
      </LimitedListContext.Provider>

      {((!!countShowed && ((total && total > limit) || items.length > limit)) ||
        showButton) && (
        <>
          {buttonSpacing && <Spacing spacing={buttonSpacing} />}

          <Button
            block
            color='blue'
            view='outline'
            onClick={onClickShowAll}
            StartIcon={isAuthNeed && !isAuth && <UnlockIcon width='20px' height='20px' />}
          >
            {buttonText}
          </Button>
        </>
      )}
    </div>
  )
}

export { LimitedList }
export default memo(LimitedList)
